import type {
  ScoutChatMessage as StoredScoutChatMessage,
  ScoutMessagePart as ScoutChatMessagePart,
  ScoutTextPart,
  ScoutToolPart,
  ScoutToolState,
} from "../../hooks/types";

export type { ScoutChatMessagePart, ScoutTextPart, ScoutToolPart, ScoutToolState };

export type ScoutChatMessage = Omit<StoredScoutChatMessage, "content" | "parts"> & {
  content?: string;
  parts: ScoutChatMessagePart[];
};

export function getScoutMessageTextParts(parts: ScoutChatMessagePart[]): string[] {
  return parts.flatMap((part) => {
    if (part.type !== "text") {
      return [];
    }

    const text = part.text.trim();
    return text ? [text] : [];
  });
}

export function getScoutMessageText(message: ScoutChatMessage): string {
  return getScoutMessageTextParts(message.parts).join("\n\n");
}
